import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { ITeamMember } from '@types';
import { CountryFlag, ProfilePicture } from 'components/common';
import { getCountryCode } from '@utils';

type Props = {
  teamMember: ITeamMember;
  projectId: string;
};

export const TeamMember: React.FC<Props> = ({ teamMember, projectId }) => {
  if (!teamMember) {
    return <Typography>N/A</Typography>;
  }

  return (
    <Box
      component={RouterLink}
      to={`/teams/${projectId}/members/${teamMember.id}`}
      display="flex"
      gap={1}
      sx={{
        textDecoration: 'none',
        color: 'inherit',
        alignItems: 'center',
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <ProfilePicture url={teamMember.avatarUrl} />
        {getCountryCode(teamMember.legalLocation) && (
          <CountryFlag
            country={teamMember.legalLocation}
            sx={{
              position: 'absolute',
              right: -4,
              bottom: -4,
            }}
          />
        )}
      </Box>
      <Box>
        <Typography>{teamMember.fullName}</Typography>
        <Typography color="text.secondary">
          {teamMember.seniority} {teamMember.stream}
        </Typography>
      </Box>
    </Box>
  );
};
